import React, { useState, useEffect, useContext } from 'react'
import { useMediaQuery, useTheme } from '@material-ui/core'
import { useLocation, useHistory } from "react-router-dom"
import { Link } from 'react-router-dom'
import useStyles from './styles'
import clsx from 'clsx'
import SideNavigationView from './SideNavigationView'
import { MenuPopover, Image } from 'shared/ui'
import { goapp_logo_white } from 'assets/images'
import {
  Button,
  Typography,
  Box,
  Badge,
} from '@material-ui/core'

import {
  Home as HomeIcon,
  ExpandMore
} from '@material-ui/icons'

const NavigationBar = ({ variant, title, menuItems, notificationItems, closePopoverNotification = false }) => {

  const [popoverAnchorEl, setPopoverAnchorEl] = useState(null)
  const [popoverMenuItems, setPopoverMenuItems] = useState(null)
  const [popoverMenuId, setPopoverMenuId] = useState(null)
  const classes = useStyles()
  const theme = useTheme()
  const smDown = useMediaQuery(theme.breakpoints.down("sm"))
  const [openSideMenu, setOpenSideMenu] = useState(false)
  const history = useHistory()

  const showPopoverMenu = (target, menuItems, itemId) => {
    setPopoverMenuId(itemId)
    setPopoverMenuItems(menuItems)
    setPopoverAnchorEl(target)

    /** mark ar read when open the popover notification */
    if (menuItems.some(some => some.markReadNotification)) {
      menuItems?.filter(item => item?.markReadNotification)?.[0]?.markReadNotification()
    }
  }

  const hidePopoverMenu = () => {
    setPopoverMenuItems(null)
    setPopoverAnchorEl(null);
  }

  useEffect(() => {
    hidePopoverMenu()
  }, [closePopoverNotification])

  useEffect(() => {
    if (!popoverAnchorEl || !popoverMenuId) return

    const sourceItem = [...notificationItems].find(item => item.id === popoverMenuId)
    if (sourceItem?.actionItems) {
      setPopoverMenuItems(sourceItem.actionItems)
    }
  }, [notificationItems])
  
  let rootStyle = {}
  /*
  if (variant == 'transparent')
    rootStyle['backgroundColor'] = 'inherit'
  else if (backgroundColor)
    rootStyle['backgroundColor'] = backgroundColor
  */

  return (
    <div className={classes.navigationBar}
      style={rootStyle}
    >
      {smDown ?
        <div className={classes.navigationBarLeftPanel}>
          {/*
          <Button onClick={() => setOpenSideMenu(!openSideMenu)}>
            <HomeIcon />
          </Button>
          <SideNavigationView
            open={openSideMenu}
            onClose={() => setOpenSideMenu(false)}
            title={title}
            menuItems={menuItems}
          />
          */}
        </div>
        :
        <>
          <div className={classes.navigationBarLeftPanel}>
            <Box ml={1} mr={3}>
              <Image src={goapp_logo_white} fitting="contain" style={{ height: '1.2rem', marginTop: '2px', width: 'unset' }} />
            </Box>

            {/* <Box ml={1} mr={3}>
              <Typography color='' className={classes.navigationBarTitle}>
                {title}
              </Typography>
            </Box> */}

            {menuItems.map(item =>
              <Box className={classes.navigationBarButtonWrapper}>
                {item.selected &&
                  <div className={classes.navigationBarSelectedButtonIndicator} />
                }

                <Button color='inherit'
                  className={clsx(classes.navigationBarButton, item.selected && classes.navigationBarSelectedButton)}
                  component={item.actionItems?.length === 0 && !item.onItemClick ? Link : "button"}
                  to={item.actionItems?.length === 0 && !item.onItemClick ? item.linkTo : undefined}
                  onClick={(event) => {
                    if (item.actionItems?.length > 0) {
                      showPopoverMenu(event.target, item.actionItems, item.id)
                    } else if (item.onItemClick) {
                      item.onItemClick()
                    }
                  }}
                >
                  {item.title || item.label}
                  {item.actionItems.length > 0 && (
                    <ExpandMore />
                  )}
                </Button>
              </Box>
            )}
          </div>
          <div className={classes.navigationBarCenterPanel}>
          </div>
        </>
      }

      <div className={classes.navigationBarNotificationPanel}>
        {notificationItems.map(item =>
          <Box>
            <Button
              className={clsx(classes.notificationItemButton, item?.classNameItemButton)}
              onClick={(event) => {
                if (item?.additionalAction) {
                  item?.additionalAction()
                }

                if (item.actionItems) {
                  showPopoverMenu(event.target, item.actionItems, item.id)
                }
                else if (item.linkTo)
                  history.push(item.linkTo)
                else if (item.onItemClick)
                  item?.onItemClick()
              }}
            >
              <Badge variant={item.badgeVariant || "standard"}
                classes={{ badge: item.badgeClassName }}
                overlap={item.badgeOverlap || "rectangle"}
                badgeContent={item.badgeContent}
                invisible={item.badgeVariant === "dot" ? item?.isBadgeInvisible : undefined}
              >
                {Boolean(item.icon) && React.createElement(item.icon, {
                  className: classes.notificationItemIcon,
                })}
                {!item.icon && item.iconRender && item.iconRender()}
              </Badge>
              {item.label &&
                <Box ml={1}>
                  {item.label}
                </Box>
              }
            </Button>
          </Box>
        )}
        {popoverMenuItems && popoverAnchorEl &&
          <MenuPopover
            // key={popoverAnchorEl?.id || JSON.stringify(popoverMenuItems)}
            menuItems={popoverMenuItems}
            open={true}
            anchorEl={popoverAnchorEl}
            onClose={hidePopoverMenu}
          />
        }
      </div>
    </div>
  )
}

export default NavigationBar